import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BeforeAfterSection() {
  const before = ['ideas sueltas', 'desorden', 'confusión', 'miedo a lo técnico', 'no saber por dónde empezar', 'seguir postergando tu lanzamiento', 'mirar contenido sin convertirlo en acción', 'seguir sin ventas'];
  const after = ['más claridad', 'producto mejor estructurado', 'tienda creada', 'pagos conectados', 'anuncios mejor entendidos', 'sistema más ordenado', 'más velocidad de ejecución', 'primeras ventas mucho más cerca'];
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gray-900 text-white py-16 md:py-24 px-4" data-id="element-43">
      <div className="max-w-6xl mx-auto" data-id="element-44">
        <h2 className="text-4xl md:text-5xl font-black mb-16 text-center" data-id="element-45">
          Antes vs Después
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-46">
          <div className="bg-red-900 bg-opacity-30 rounded-2xl p-8 border-2 border-red-500" data-id="element-47">
            <h3 className="text-3xl font-bold mb-8 text-red-300" data-id="element-48">
              Antes de Dominando Shopify
            </h3>
            <div className="space-y-4" data-id="element-49">
              {before.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-50">
                  <span className="text-red-400 text-xl" data-id="element-51">✗</span>
                  <span className="text-gray-300" data-id="element-52">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-green-900 bg-opacity-30 rounded-2xl p-8 border-2 border-green-500" data-id="element-53">
            <h3 className="text-3xl font-bold mb-8 text-green-300" data-id="element-54">
              Después de Dominando Shopify
            </h3>
            <div className="space-y-4" data-id="element-55">
              {after.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-56">
                  <span className="text-green-400 text-xl" data-id="element-57">✓</span>
                  <span className="text-gray-200" data-id="element-58">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-59">
          <CTAButton text="QUIERO CREAR MI NEGOCIO ONLINE" onClick={scrollToCompra} size="large" data-id="element-60" />
        </div>
      </div>
    </section>;
}